import styled from 'styled-components'
import { em } from 'polished'

import { BoxBase } from 'styles/components/layout'
import { Text } from 'shared/Typography'
import { Button } from 'shared/Button'

export const Wrapper = styled.div`
  padding-top: ${em(40)};
  padding-bottom: ${em(40)};
  overflow: hidden;

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(80)};
    padding-bottom: ${em(80)};
  }
`

export const Container = styled(BoxBase)`
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${em(10)};

  ${p => p.theme.mq.upLg} {
    justify-content: space-between;
    margin-bottom: ${em(20)};
  }
`

export const Title = styled(Text)`
  ${p => p.theme.mq.upLg} {
    max-width: ${em(558, 50)};
  }

  span {
    font-weight: 500;
  }
`

export const Description = styled(Text)`
  margin-bottom: ${em(30, 16)};
  text-align: center;

  ${p => p.theme.mq.upLg} {
    max-width: ${em(603, 22)};
    margin-bottom: ${em(50, 22)};
    text-align: left;
  }
`
export const ButtonStyled = styled(Button)`
  > button {
    border-color: var(--color-D10) !important;

    ${({ theme }) => theme.mq.upLg} {
      font-size: ${em(18)} !important;
      height: ${em(50, 18)} !important;
      line-height: ${em(24, 18)} !important;
      padding-left: ${em(20, 18)} !important;
      padding-right: ${em(30, 18)} !important;
    }
  }

  svg {
    width: ${em(45)};
  }
`

export const YoutubeContainer = styled.div`
  display: grid;
  gap: ${em(30)};
  grid-template-columns: repeat(1, 1fr);
  overflow: hidden;
  max-width: 100%;
  margin-bottom: ${em(30)};

  ${p => p.theme.mq.upMd} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${p => p.theme.mq.upLg} {
    grid-template-columns: repeat(4, 1fr);
    gap: ${em(40)};
    margin-bottom: 0;
  }
`
